import { useEffect, useState } from 'react';
import { fetchMilestoneTemplateActionsForRuntime } from '../services/workflowRuntimeService';

/**
 * Charge les actions workflow par milestone_template_id pour les phases d’un dossier.
 * @param {{ items?: Array<{ milestones?: Array<{ milestone_template_id?: string }> }> }} phases
 */
export function useMilestoneTemplateActionsMap(phases) {
  const [templateActionsByTemplateId, setTemplateActionsByTemplateId] = useState({});

  useEffect(() => {
    const items = phases?.items;
    if (!items?.length) {
      setTemplateActionsByTemplateId({});
      return undefined;
    }

    const ids = new Set();
    items.forEach((p) =>
      (p.milestones || []).forEach((m) => {
        if (m.milestone_template_id) ids.add(m.milestone_template_id);
      }),
    );

    if (ids.size === 0) {
      setTemplateActionsByTemplateId({});
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const pairs = await Promise.all(
          [...ids].map(async (tid) => {
            const rows = await fetchMilestoneTemplateActionsForRuntime(tid);
            rows.sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
            return [tid, rows];
          }),
        );
        if (!cancelled) setTemplateActionsByTemplateId(Object.fromEntries(pairs));
      } catch (e) {
        console.error('[useMilestoneTemplateActionsMap]', e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [phases]);

  return templateActionsByTemplateId;
}
